import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgTooltip',
})
export default class CmgTooltip extends Vue {
  @Prop({default: 'brown', type: String })
  background?: string;
}
